import React, { useEffect, useState } from 'react';
import './Approvisionnement.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Stock = () => {

  useEffect(() => {
    document.title = 'MYSSA – Base stock';
  }, []);

  const [stockData, setStockData]         = useState([]);
  const [filterFamille, setFilterFamille] = useState('');
  const [filterItem, setFilterItem]       = useState('');
  const [filterDepot, setFilterDepot]     = useState('');
  const [filterLibelle, setFilterLibelle] = useState('');

  const excludedColumns = ["id", "Client_id"];

  useEffect(() => {
    fetch(`${API}/base_de_donne_stock`)
      .then(r => r.json())
      .then(d => setStockData(d))
      .catch(err => console.error(err));
  }, []);

  const resetFilters = () => {
    setFilterFamille(''); setFilterItem('');
    setFilterDepot('');   setFilterLibelle('');
  };

  const filteredData = stockData.filter(row =>
    (filterFamille === '' || row["Famille produit"]?.toLowerCase().includes(filterFamille.toLowerCase())) &&
    (filterItem    === '' || row["Item"]?.toLowerCase().includes(filterItem.toLowerCase())) &&
    (filterDepot   === '' || row["Nom Dépôt"]?.toLowerCase().includes(filterDepot.toLowerCase())) &&
    (filterLibelle === '' || row["Description"]?.toLowerCase().includes(filterLibelle.toLowerCase()))
  );

  const coupleMap = {};
  stockData.forEach(row => {
    const key = `${row["Nom Dépôt"] ?? ''}-${row["Emplacement"] ?? ''}`;
    coupleMap[key] = (coupleMap[key] || 0) + 1;
  });
  const duplicateCouples = new Set(
    Object.entries(coupleMap).filter(([, v]) => v > 1).map(([k]) => k)
  );

  // ── Export Excel ──────────────────────────────────────────────────────────
  const exportToExcel = () => {
    const exportRows = filteredData.map(row =>
      Object.fromEntries(
        Object.entries(row).filter(([k]) => !excludedColumns.includes(k))
      )
    );
    const ws  = XLSX.utils.json_to_sheet(exportRows);
    const wb  = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stock');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const date = new Date().toISOString().slice(0, 10);
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `stock_${date}.xlsx`);
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const inputStyle = {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontSize: '12px',
    padding: '6px 10px',
    border: '1px solid #e2d9cc',
    borderRadius: '6px',
    outline: 'none',
    background: '#fdfcfa',
    color: '#1e293b',
    width: '160px',
    height: '34px',
    boxSizing: 'border-box',
  };

  const btnStyle = {
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: '11px',
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    border: '1px solid #d4c9b8',
    borderRadius: '6px',
    background: 'linear-gradient(180deg, #04202d, #38bdf8)',
    color: 'white',
    cursor: 'pointer',
    width: '160px',
    height: '34px',
    boxSizing: 'border-box',
    padding: '0',
    flexShrink: 0,
  };

  const btnExportStyle = {
    ...btnStyle,
    background: '#ffffff',
    color: '#04202d',
    border: '1px solid #d4c9b8',
  };

  const columns = stockData.length > 0
    ? Object.keys(stockData[0]).filter(k => !excludedColumns.includes(k))
    : [];

  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>

      {/* Bandeau titre */}
      <div style={{ position: 'absolute', top: '25px', left: '160px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px' }} />
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '200', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#04202d' }}>
          Stock
        </span>
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '80px', marginLeft: '-20px', marginBottom: '12px' }}>
        {[
          { placeholder: 'Famille produit…', value: filterFamille, setter: setFilterFamille },
          { placeholder: 'Item…',             value: filterItem,    setter: setFilterItem },
          { placeholder: 'Nom Dépôt…',        value: filterDepot,   setter: setFilterDepot },
          { placeholder: 'Description…',      value: filterLibelle, setter: setFilterLibelle },
        ].map(({ placeholder, value, setter }) => (
          <input key={placeholder} style={inputStyle} placeholder={placeholder}
            value={value} onChange={e => setter(e.target.value)} />
        ))}
        <button style={btnStyle} onClick={resetFilters}>Réinitialiser</button>
        <button style={btnExportStyle} onClick={exportToExcel}>Export Excel</button>
      </div>

      {/* Tableau */}
      <div className="table-container1" style={{ marginLeft: '-40px', maxWidth: '1800px', maxHeight: '600px', marginTop: '80px' }}>
        <table>
          <thead>
            <tr>{columns.map(k => <th key={k}>{k}</th>)}</tr>
          </thead>
          <tbody>
            {filteredData.map((row, index) => {
              const key         = `${row["Nom Dépôt"] ?? ''}-${row["Emplacement"] ?? ''}`;
              const isDuplicate = duplicateCouples.has(key);
              return (
                <tr key={index}>
                  {columns.map((k, i) => (
                    <td key={i} style={isDuplicate && (k === "Nom Dépôt" || k === "Emplacement")
                      ? { backgroundColor: '#FFF8E6', color: '#B7770D' } : {}}>
                      {row[k]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Stock;